import gql from 'graphql-tag';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Hideable from './Hideable';
import Validate from './Validate';
import SignInThirdParty from './SignInThirdParty';
import { Alert, Box, Button, Container, Divider, Grid, Link, Paper, Stack, TextField, Typography } from '@mui/material';
import { useDrawer } from './context/DrawerContext';
import SignUpButton from './SignUpButton';

const SIGN_IN_WITH_PASSWORD = gql`
mutation SignInWithPassword($email:String!, $password:String!) {
  signInWithPassword(email:$email, password:$password)
}`
  ;

const SignIn = props => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const { openDrawer } = useDrawer();
  let navigate = useNavigate();

  document.title = `navscout - Sign In`;

  return (
    <Grid container  sx={{ minHeight: '100vh' }}>
      <Paper elevation={0} sx={{ padding: { xs: 3, sm: 5 }, width: '100%' }}>
        <Box  mb={4}>
          <Typography variant="h4" component="h1" gutterBottom>
            Sign in to navscout
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Welcome back! It's good to see you again. Sign in to get the latest travel conditions and a live forecast for your route.
          </Typography>
        </Box>

        <form
          onSubmit={e => {
            e.preventDefault();
            signInWithPassword(props.client, { email, password }, navigate, setError);
          }}
        >
          <Stack spacing={2.5}>
            <TextField
              fullWidth
              name='email'
              label='Email'
              placeholder='Email'
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <TextField
              fullWidth
              type='password'
              label='Password'
              name='password'
              placeholder='Password'
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <Link
              component="button"
              variant="body2"
              onClick={() => openDrawer('get-token')}
              alignSelf="flex-end"
              sx={{ mt: -1.5, mb: 1 }}
            >
              Forgot password?
            </Link>
            <Button
              fullWidth
              disabled={!Validate.notBlank(email, password)}
              variant='contained'
              type="submit"
            >
              Sign In
            </Button>
          </Stack>
        </form>

        <Divider sx={{ my: 4 }}>
          <Typography variant="body2" color="text.secondary">
            OR
          </Typography>
        </Divider>

        <Stack spacing={2}>
          <SignInThirdParty account={props.account} client={props.client} />
          <SignUpButton />
        </Stack>

        <Hideable hidden={!error}>
          <Alert severity='error' sx={{ mt: 3 }}>
            {error}
          </Alert>
        </Hideable>
      </Paper>
    </Grid>
  );

}

const signInWithPassword = (client, values, navigate, setError) => {
  client.mutate({
    mutation: SIGN_IN_WITH_PASSWORD,
    variables: values,
    refetchQueries: ['Account', 'Alerts', 'FindPlace', 'GetCalendar', 'Places']
  }).then(data => {
    if (data.data.signInWithPassword === null) {
      setError('Sign In failed');
    } else {
      window.location.reload()
    }
  }).catch(error => setError(error.message));
}


export default SignIn;